import { render, staticRenderFns } from "./DictionaryItem.vue?vue&type=template&id=330a99a7&scoped=true&"
import script from "./DictionaryItem.vue?vue&type=script&lang=js&"
export * from "./DictionaryItem.vue?vue&type=script&lang=js&"
import style0 from "./DictionaryItem.vue?vue&type=style&index=0&id=330a99a7&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "330a99a7",
  null
  
)

export default component.exports